import React from "react";
import { NAV_LINKS, VALUES, STATS, SERVICES, QUOTE, BRAND, IMAGES } from "../mock";

const scrollTo = (e, href) => {
  if (href && href.startsWith("#")) {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }
};

export const Navbar = ({ scrolled, menuOpen, setMenuOpen, onRegister }) => (
  <nav className={scrolled ? "scrolled" : ""}>
    <div className="inner">
      <a href="#top" className="logo" onClick={(e) => scrollTo(e, "#top")}>
        <img className="logo-white" src={BRAND.logoWhite} alt="Wynridge" />
        <img className="logo-ink" src={BRAND.logoInk} alt="Wynridge" />
      </a>
      <div className={`nl${menuOpen ? " open" : ""}`}>
        {NAV_LINKS.map((l) => (
          <a key={l.href} href={l.href} onClick={(e) => { scrollTo(e, l.href); setMenuOpen(false); }}>{l.label}</a>
        ))}
        <a href="#register" className="pill" onClick={(e) => { e.preventDefault(); setMenuOpen(false); onRegister(); }}>Register Interest</a>
      </div>
      <button className={`menu-btn${menuOpen ? " x" : ""}`} aria-label="Menu" onClick={() => setMenuOpen((o) => !o)}>
        <span></span><span></span><span></span>
      </button>
    </div>
  </nav>
);

export const Hero = ({ onRegister }) => (
  <section className="card hero" id="top" style={{ backgroundImage: `url('${IMAGES.hero}')` }}>
    <div className="cap"><div className="inner"><p>Active Adult Living · 55+ — a new kind of community.</p></div></div>
    <div className="body"><div className="inner">
      <h1 className="display">More life. Less hassle.<br />The best years, <em>by design</em>.</h1>
      <p className="sub">A beautifully designed, maintenance-free home in a community made for connection, freedom, and more out of every day. The upgrade you've earned.</p>
      <div className="row">
        <a href="#register" className="pill pill-light" onClick={(e) => { e.preventDefault(); onRegister(); }}>Register Your Interest</a>
        <a href="#life" className="pill pill-ghost" onClick={(e) => scrollTo(e, "#life")}>Take a Look</a>
        <span className="badge"><img src={BRAND.markBadge} alt="" />Life, by design.</span>
      </div>
    </div></div>
  </section>
);

export const Manifesto = () => (
  <section className="card manifesto pad" id="story">
    <div className="dots"><i></i><i></i><i></i><i></i></div>
    <div className="inner reveal">
      <h2 className="display">You've done the hard part.<br /><em>Now comes the best part.</em></h2>
      <p>A home that maintains itself. A community that shows up. And the freedom to spend every single day exactly as you please.</p>
      <img className="mark" src={BRAND.mark} alt="" />
    </div>
  </section>
);

export const Values = () => (
  <section className="card values pad" id="why">
    <div className="inner">
      <div className="head reveal">
        <span className="eyebrow">Why Wynridge</span>
        <h2 className="display">We'll handle the upkeep. <em>You handle the living.</em></h2>
      </div>
      <p className="sub reveal">We take on everything that used to eat your weekends — the maintenance, the worry, the upkeep. You take back your time.</p>
      <div className="vgrid">
        {VALUES.map((v, i) => (
          <div key={i} className={`vcard reveal${v.dark ? " dark" : ""}`}>
            <div className="ph"><img src={v.img} alt={v.alt} loading="lazy" /></div>
            <div className="bd">
              <h3>{v.title}</h3>
              <p>{v.text}</p>
              {v.more && <span className="ml arrow">{v.more} </span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const Stats = () => (
  <section className="card stats">
    <div className="grid">
      <div className="panel">
        <div className="row reveal">
          {STATS.map((s, i) => (
            <div className="stat" key={i}><div className="n">{s.n}</div><div className="l">{s.l}</div></div>
          ))}
        </div>
        <h2 className="display reveal">An upgrade in <em>every way</em> that matters.</h2>
        <div className="qcard reveal">
          <div className="top">
            <div className="av"><img src={BRAND.markBadge} alt="" /></div>
            <div><div className="nm">{QUOTE.name}</div><div className="rl">{QUOTE.role}</div></div>
          </div>
          <blockquote>{QUOTE.text}</blockquote>
          <span className="tag">{QUOTE.tag}</span>
        </div>
      </div>
      <div className="pic" role="img" aria-label="Residents enjoying morning movement on the deck" style={{ backgroundImage: `url('${IMAGES.statsDeck}')` }}></div>
    </div>
  </section>
);

export const Services = () => (
  <section className="card serv pad" id="life">
    <div className="inner">
      <div className="top">
        <div className="reveal">
          <span className="eyebrow">Life at Wynridge</span>
          <h2 className="display" style={{ marginTop: 12 }}>Designed around your life.<br /><em>Not the other way around.</em></h2>
        </div>
      </div>
      <div className="sgrid">
        {SERVICES.map((s, i) =>
          s.image ? (
            <div key={i} className="scard img reveal">
              <img src={s.img} alt={s.alt} loading="lazy" />
              <div className="ov"><h3>{s.title}</h3><p>{s.text}</p></div>
            </div>
          ) : (
            <div key={i} className="scard reveal">
              <img className="ic" src={s.icon} alt="" />
              <h3>{s.title}</h3>
              <p>{s.text}</p>
            </div>
          )
        )}
      </div>
    </div>
  </section>
);
